/**
 * Button — shared button primitive
 * Mirrors the btn-primary / btn-secondary conventions in customStyles.js
 *
 * Props:
 *   variant   {'primary'|'secondary'|'danger'|'ghost'} default 'primary'
 *   size      {'sm'|'md'|'lg'} default 'md'
 *   disabled  {boolean}
 *   className {string}
 *   children  {React.ReactNode}
 *   ...rest   passed to <button>
 */
const variantClasses = {
  primary: 'bg-[#FFA726] text-white hover:shadow-md hover:-translate-y-px active:translate-y-0',
  secondary: 'bg-[#17386E] text-white hover:bg-[#2a5298] hover:-translate-y-px active:translate-y-0',
  danger: 'bg-red-600 text-white hover:bg-red-700 hover:-translate-y-px active:translate-y-0',
  ghost: 'bg-transparent text-[#17386E] border border-[#17386E] hover:bg-[#EAF4FB]',
};

const sizeClasses = {
  sm: 'px-3 py-1.5 text-sm',
  md: 'px-4 py-2 text-sm',
  lg: 'px-6 py-3 text-base',
};

const Button = ({
  variant = 'primary',
  size = 'md',
  disabled = false,
  className = '',
  children,
  ...rest
}) => {
  return (
    <button
      disabled={disabled}
      className={[
        'inline-flex items-center justify-center rounded-lg font-montserrat font-semibold transition-all duration-200',
        variantClasses[variant] ?? variantClasses.primary,
        sizeClasses[size] ?? sizeClasses.md,
        disabled ? 'opacity-50 cursor-not-allowed pointer-events-none' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;
